export default __webpack_public_path__ + "static/media/blogmodalimg2.1f7a9cee.jfif";